import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { SpecificationContentType } from '../../enums';
import { CommonSection } from './common-section';

@injectable()
export class AbstractSection extends CommonSection {
    readonly contentType = SpecificationContentType.Abstract;
}
